import React from 'react';
import Editor from '@monaco-editor/react';

function CodeEditor({ file }) {
  const getLanguage = (path) => {
    const ext = path.split('.').pop();
    const langMap = {
      ts: 'typescript',
      tsx: 'typescript',
      js: 'javascript',
      jsx: 'javascript',
      json: 'json',
      css: 'css',
      html: 'html',
      md: 'markdown',
      py: 'python',
    };
    return langMap[ext] || 'plaintext';
  };

  if (!file) {
    return (
      <div className="h-full flex items-center justify-center bg-gray-900 text-gray-500">
        <div className="text-center">
          <p className="text-lg mb-2">No file selected</p>
          <p className="text-sm">
            Select a file from the tree or chat with AI to generate code.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <div className="h-10 bg-gray-800 border-b border-gray-700 flex items-center px-4">
        <span className="text-sm text-gray-300">{file.path}</span>
      </div>
      <Editor
        height="calc(100% - 2.5rem)"
        language={getLanguage(file.path)}
        value={file.content}
        theme="vs-dark"
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          lineNumbers: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          readOnly: true,
        }}
      />
    </div>
  );
}

export default CodeEditor;
